/* @flow */

import * as React from 'react';
import { createUseStyles } from 'react-jss';

import styles from './FooterLink.style';
import BaseLink from './BaseLink';

import type { Link } from './type/linkTypes';

type Props = Link;

const useStyles = createUseStyles(styles);

const FooterLink = ({ href, handleClick, children }: Props): React.Node => {
  const classes: Object = useStyles();

  return (
    <BaseLink className={classes.root} href={href} handleClick={handleClick}>
      {children}
    </BaseLink>
  );
};

export default FooterLink;
